/**
 * FKX SOON — single global countdown controller.
 * Unix launch timestamp is the source of truth (UTC seconds).
 */
(function () {
  if (window.FkxSoon && window.FkxSoon.__initialized) return;

  function pad2(value) {
    return String(value).padStart(2, '0');
  }

  function parseLaunchTimestamp(raw) {
    var ts = Number(String(raw == null ? '' : raw).trim());
    if (!Number.isFinite(ts) || ts <= 0) return null;
    return ts * 1000;
  }

  var DAY_MS = 24 * 60 * 60 * 1000;

  function formatDaysUntilDrop(days) {
    var config = window.fkxSoonConfig || {};
    var template = days === 1
      ? (config.daysUntilDropOne || '__COUNT__ day until the drop')
      : (config.daysUntilDropOther || '__COUNT__ days until the drop');
    return String(template).replace(/__COUNT__/g, String(days));
  }

  function formatCountdown(msLeft) {
    // Above 24h: "1 dzień do dropa" / "2 days until the drop".
    // At 24:00:00 and below: classic HH:MM:SS timer.
    if (msLeft > DAY_MS) {
      var days = Math.floor(msLeft / DAY_MS);
      return formatDaysUntilDrop(Math.max(1, days));
    }

    var totalSeconds = Math.max(0, Math.floor(msLeft / 1000));
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    return pad2(hours) + ':' + pad2(minutes) + ':' + pad2(seconds);
  }

  function getReadyLabel(button) {
    var custom = button.getAttribute('data-fkx-soon-ready-label');
    if (custom) return custom;
    var config = window.fkxSoonConfig || {};
    if (config.buttonTextAfter) return config.buttonTextAfter;
    if (window.variantStrings && window.variantStrings.addToCart) return window.variantStrings.addToCart;
    return 'ADD TO CART';
  }

  function getSoldOutLabel() {
    if (window.variantStrings && window.variantStrings.currentlyUnavailable) {
      return String(window.variantStrings.currentlyUnavailable);
    }
    if (window.variantStrings && window.variantStrings.soldOut) {
      return String(window.variantStrings.soldOut);
    }
    return 'Sold out';
  }

  function resolveVariantForButton(button) {
    var productForm = button.closest('product-form');
    if (!productForm || typeof productForm.resolveSelectedVariant !== 'function') return null;
    return productForm.resolveSelectedVariant();
  }

  function syncButtonFromVariant(button) {
    var span = button.querySelector('[data-fkx-soon-text]') || button.querySelector('span');
    if (!span) return;

    var variant = resolveVariantForButton(button);
    var soldOut = !!(variant && variant.available === false);
    var readyLabel = getReadyLabel(button);

    button.classList.remove('fkx-soon-active', 'is-variant-updating');
    button.removeAttribute('data-fkx-soon-locked');
    button.removeAttribute('aria-busy');

    if (soldOut) {
      button.type = 'submit';
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-sold-out');
      span.textContent = getSoldOutLabel();
      return;
    }

    button.type = 'submit';
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.classList.remove('is-sold-out');
    span.textContent = readyLabel;
  }

  var FkxSoonController = {
    __initialized: true,
    timerId: null,
    targetMs: null,
    targets: new Set(),
    variantUnsubscriber: null,

    getConfig: function () {
      return window.fkxSoonConfig || {};
    },

    isEnabled: function () {
      return !!this.getConfig().enabled;
    },

    isActive: function () {
      if (!this.isEnabled() || this.targetMs == null) return false;
      return Date.now() < this.targetMs;
    },

    isBlocking: function (button) {
      if (!button) return false;
      return this.isActive() && (button.hasAttribute('data-fkx-soon-atc') || button.getAttribute('data-fkx-soon-locked') === 'true');
    },

    scan: function () {
      var nodes = document.querySelectorAll('[data-fkx-soon-atc]');
      this.targets = new Set(Array.prototype.slice.call(nodes));
      document.querySelectorAll('[data-fkx-soon-message]').forEach(function (messageEl) {
        messageEl.hidden = !FkxSoonController.isActive() || !String(FkxSoonController.getConfig().customMessage || '').trim();
      });
    },

    lockButton: function (button, label) {
      var span = button.querySelector('[data-fkx-soon-text]') || button.querySelector('span');
      if (!span) return;

      button.type = 'button';
      button.setAttribute('data-fkx-soon-locked', 'true');
      button.setAttribute('aria-disabled', 'true');
      button.removeAttribute('disabled');
      button.removeAttribute('aria-busy');
      button.classList.add('fkx-soon-active');
      button.classList.remove('is-sold-out', 'is-variant-updating', 'loading');
      span.classList.remove('hidden');
      span.textContent = label;
    },

    releaseAll: function () {
      var self = this;
      var buttons = document.querySelectorAll('[data-fkx-soon-atc]');
      Array.prototype.forEach.call(buttons, function (button) {
        syncButtonFromVariant(button);
      });
      document.querySelectorAll('[data-fkx-soon-message]').forEach(function (messageEl) {
        messageEl.hidden = true;
      });
      this.targets = new Set(Array.prototype.slice.call(buttons));
      this.stopTimer();
    },

    tick: function () {
      this.scan();

      if (!this.isEnabled() || this.targetMs == null) {
        this.releaseAll();
        return;
      }

      var remaining = this.targetMs - Date.now();
      if (remaining <= 0) {
        // Reload only after a live countdown ends — not when the page loads already past launch.
        var shouldReload = this.timerId != null;
        this.releaseAll();
        if (shouldReload) {
          window.location.reload();
        }
        return;
      }

      var label = formatCountdown(remaining);
      this.targets.forEach(function (button) {
        FkxSoonController.lockButton(button, label);
      });

      document.querySelectorAll('[data-fkx-soon-message]').forEach(function (messageEl) {
        messageEl.hidden = !String(FkxSoonController.getConfig().customMessage || '').trim();
      });
    },

    startTimer: function () {
      if (this.timerId != null) return;
      var self = this;
      this.timerId = window.setInterval(function () {
        self.tick();
      }, 1000);
    },

    stopTimer: function () {
      if (this.timerId == null) return;
      window.clearInterval(this.timerId);
      this.timerId = null;
    },

    bindEvents: function () {
      if (this._eventsBound) return;
      this._eventsBound = true;

      var self = this;

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, function () {
          window.setTimeout(function () {
            if (self.isActive()) self.tick();
            else self.releaseAll();
          }, 0);
        });
      }

      document.addEventListener('shopify:section:load', function () {
        self.refresh();
      });

      document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-fkx-soon-atc][data-fkx-soon-locked]');
        if (!button || !self.isBlocking(button)) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    },

    init: function () {
      var config = this.getConfig();
      this.targetMs = parseLaunchTimestamp(config.launchTimestamp);

      this.bindEvents();

      if (!this.isEnabled() || this.targetMs == null) {
        this.releaseAll();
        return;
      }

      this.tick();

      if (this.isActive()) this.startTimer();
      else this.releaseAll();
    },

    refresh: function () {
      this.targetMs = parseLaunchTimestamp(this.getConfig().launchTimestamp);
      this.tick();
      if (this.isActive()) this.startTimer();
    }
  };

  window.FkxSoon = FkxSoonController;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      FkxSoonController.init();
    }, { once: true });
  } else {
    FkxSoonController.init();
  }
})();
